import {
  Dialog,
  DialogContent,
  DialogCloseButton,
  DialogHeader,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

export const DialogUpdateSatuanPendidikanInfo = ({ isOpen, onClose }) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} size="sm">
      <DialogOverlay />
      <DialogContent>
        <DialogHeader title="Cara perbarui data satuan pendidikan" />
        <DialogCloseButton onClick={onClose} />
        <div className="p-6">
          <Text>
            Mohon <strong>kabari operator Simtendik</strong> untuk memperbarui
            data satuan pendidikan Anda.
          </Text>
        </div>
      </DialogContent>
    </Dialog>
  )
}
